export default __webpack_public_path__ + "static/qrcode-f2e618bc9b1de4b1610e408b0a50469e.svg";